import { UploadUrl } from "../base-url.js";

//#region ../base/upload/methods/external.ts
var UploadExternal = class extends UploadUrl {};

//#endregion
export { UploadExternal };